// extracted by mini-css-extract-plugin
export var tosLink = "_64-0";